/**
 * Panel actions: the stage's + add-element menu and the flooring-type
 * rename. The ⊕ menu's add is core's `addEdgeItem`, shared with Kai Pro.
 */
import { CustomAreaType } from '@kaiizen/kai-floor-plan';
import { addFreeElement, duplicateSelectedFreeElement, FloorPlanEditorState } from '@kaiizen/kai-floor-plan-editor-core';

/** Add a free element of the given kind and select it (the + add-element menu). */
export const addFreeElementOfKind = (floorPlanEditorState: FloorPlanEditorState, kind: CustomAreaType): void =>
  floorPlanEditorState.mutate(state => addFreeElement(state, kind));

/** The + menu's Duplicate: a complete copy of the selected free element, 4 in right and down, selected. */
export const duplicateSelectedElement = (floorPlanEditorState: FloorPlanEditorState): void =>
  floorPlanEditorState.mutate(state => duplicateSelectedFreeElement(state));
